export default __webpack_public_path__ + "static/media/charisma.deb102bd.png";